export const style = {
  day: {
    textAlign: `center`,
    fontSize: `60px`,
    lineHeight: `50px`,
    fontWeight: 400,
    color: `#313131`
  },
  date: {
    textAlign: `center`,
    fontSize: `14px`,
    fontWeight: 400,
    color: `#313131`,
    textTransform: `uppercase`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/SingleArticle/style/date.js